import React, { useMemo, useState } from 'react'
import Divider from 'LuxKit/Divider'
import MerchandiseMegaMenuContainer from './components/MerchandiseMegaMenuContainer'
import MerchandiseMegaMenuPanel from './components/MerchandiseMegaMenuPanel'
import MerchandiseMegaMenuCategoryList from './components/MerchandiseMegaMenuCategoryList'
import MerchandiseMegaMenuSubcategoryList from './components/MerchandiseMegaMenuSubcategoryList'
import MerchandiseMegaMenuFeaturedBrands from './components/MerchandiseMegaMenuFeaturedBrands'
import { MIN_SUBCATEGORIES } from '../merchandiseUtils'
import useMerchandiseBrandsList from 'hooks/Merchandise/useMerchandiseBrandsList'
import useMerchandiseCategoriesList from 'hooks/Merchandise/useMerchandiseCategoriesList'
import useMerchandiseCategories from 'hooks/Merchandise/useMerchandiseCategories'

interface Props {
  onClose: () => void
}

function MerchandiseCategoryMegaMenu(props: Props) {
  const { onClose } = props

  const [categoryIds] = useMerchandiseCategoriesList({ level: 0, sortBy: 'top' })
  const [categories] = useMerchandiseCategories({ categoryIds }, { disabled: !categoryIds?.length })

  const [hoveredCategoryId, setHoveredCategoryId] = useState<string | undefined>(undefined)
  const effectiveHoveredId = hoveredCategoryId ?? categories[0]?.id

  const hoveredCategory = categories.find(cat => cat.id === effectiveHoveredId)
  const shouldShowSubcategories = hoveredCategory && hoveredCategory.childCategoryIds.length >= MIN_SUBCATEGORIES

  const brandFilters = useMemo(() => {
    if (!effectiveHoveredId) return undefined
    return { categories: [effectiveHoveredId], sortBy: 'top' as const, limit: 12 }
  }, [effectiveHoveredId])

  const [brandIds] = useMerchandiseBrandsList(brandFilters, { disabled: !effectiveHoveredId })
  const hasSufficientBrands = brandIds.length >= 6

  if (!categories.length) return null

  return <MerchandiseMegaMenuContainer>
    <MerchandiseMegaMenuCategoryList
      categories={categories}
      onCategoryHover={setHoveredCategoryId}
      onClose={onClose}
    />
    {shouldShowSubcategories && (
      <>
        <Divider kind="secondary" direction="vertical" />
        <MerchandiseMegaMenuSubcategoryList
          category={hoveredCategory}
          onClose={onClose}
        />
        {hasSufficientBrands && (
          <>
            <Divider kind="secondary" direction="vertical" />
            <MerchandiseMegaMenuPanel>
              <MerchandiseMegaMenuFeaturedBrands
                categoryId={effectiveHoveredId}
                columns={3}
                onClose={onClose}
              />
            </MerchandiseMegaMenuPanel>
          </>
        )}
      </>
    )}
  </MerchandiseMegaMenuContainer>
}

export default MerchandiseCategoryMegaMenu
